import { render, staticRenderFns } from "./TileTotalUptime.vue?vue&type=template&id=01b6c39e"
import script from "./TileTotalUptime.vue?vue&type=script&lang=js"
export * from "./TileTotalUptime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports